import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'storeService';

const functions = {
    async get() {
        await this.sync();
        
        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncDataVersion(tableName);
    },
    async getDetail(key) {
        const currentData = await this.get();
        
        return await DBEngine.getContentDetailByKey(currentData, key);
    },
    async save(value) {
        const currentData = await this.get();

        await DBEngine.updateListData(tableName, currentData, value, (value.key ? DBEngine.syncAction().update : DBEngine.syncAction().add));
    },
    async delete(item) {
        const currentData = await this.get();

        await DBEngine.updateListData(tableName, currentData, item, DBEngine.syncAction().delete);
    }
}

export default functions;